import axiosInstance from "./api";

const BASE_URL = "chats/training";

export const NOTEBOOK_TYPES = {
  officers: "officers",
  citizens: "citizens",
};

export const getAiTrainingOverview = (
  notebookType = NOTEBOOK_TYPES.officers,
  historyPage = 1,
  historyLimit = 10,
) =>
  axiosInstance.get(BASE_URL, {
    params: { notebookType, historyPage, historyLimit },
  });

export const uploadAiTrainingSources = (
  notebookType,
  files,
  onUploadProgress,
  confirmSensitiveUpload = false,
) => {
  const formData = new FormData();
  formData.append("notebookType", notebookType);
  if (confirmSensitiveUpload) {
    formData.append("confirmSensitiveUpload", "1");
  }
  files.forEach((file) => formData.append("files", file));

  return axiosInstance.post(`${BASE_URL}/sources`, formData, {
    timeout: 180000,
    onUploadProgress,
  });
};

export const deleteAiTrainingSource = (notebookType, sourceId) =>
  axiosInstance.delete(`${BASE_URL}/sources/${encodeURIComponent(sourceId)}`, {
    params: { notebookType },
    timeout: 30000,
  });

export const addAiTrainingFaq = (data) =>
  axiosInstance.post(`${BASE_URL}/faqs`, data, { timeout: 180000 });

export const deleteAiTrainingFaq = (notebookType, faqId) =>
  axiosInstance.delete(`${BASE_URL}/faqs/${encodeURIComponent(faqId)}`, {
    params: { notebookType },
    timeout: 180000,
  });

export const retrainAiNotebook = (notebookType) =>
  axiosInstance.post(
    `${BASE_URL}/retrain`,
    { notebookType },
    { timeout: 180000 },
  );

export const getAiPrompting = () => axiosInstance.get("chats/prompting");

export const updateAiPrompting = (prompting) =>
  axiosInstance.put("chats/prompting", prompting);
